import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Shell from '../../dashboard/Shell';
import Notes from './Notes';
import './NotesPage.css';

const NotesPage = () => {
  return (
    <Shell>
      <div className="rsn-page">
        <header className="rsn-page__head">
          <Link to="/overview" className="rsn-page__back" aria-label="Back to overview">
            <ChevronLeft size={18} aria-hidden="true" />
            <span>Back</span>
          </Link>
          <div className="rsn-page__title">
            <span className="rsn-page__eyebrow">Utilities</span>
            <h1 className="rsn-page__heading">Notes</h1>
            <p className="rsn-page__sub">Personal scratchpad. Autosaves as you type.</p>
          </div>
        </header>

        <div className="rsn-page__body">
          <Notes />
        </div>
      </div>
    </Shell>
  );
};

export default NotesPage;
